import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10.25", stroke: "black", strokeWidth: "1.5", fill: "white" }),
    React.createElement("path", { d: "M17 8.28093L15.7145 7L12 10.7367L8.28545 7.03524L7 8.31617L10.7145 12.0176L7 15.7191L8.28545 17.0001L12 13.2986L15.7145 17.0001L17 15.7191L13.2855 12.0176L17 8.28093Z" })), 'CloseOutlined');
